export default __webpack_public_path__ + "static/media/arrow_right_gray.5b9e1d7e.svg";